import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import Button from "./button"
import ConditionButton from "./condition-button"
import "../styles.scss"
import MobileSubMenu from "./MobileSubMenu"
import defaultLogo from "../../images/ayvakit-logo-tablets.png"
import ismLogo from "../../images/ayvakit-logo-25mg-tablets.png"
import { AnchorLink } from "gatsby-plugin-anchor-links"

import ProductPricingSheet from "../../pdf/AYVAKIT_Product_Pricing_Sheet_HCP.pdf"

export default function Header(props) {
  const [isNavVisible, setNavVisibility] = useState(false)
  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const [homeUrl, setHomeUrl] = useState("/")
  const [homeLogo, setHomeLogo] = useState(defaultLogo)
  const [homeLogoAlt, setHomeLogoAlt] = useState("AYVAKIT® (avapritinib) logo")

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 769px)")
    mediaQuery.addListener(handleMediaQueryChange)
    handleMediaQueryChange(mediaQuery)

    switch (props.site) {
      case "gist":
        console.log("gist")
        setHomeUrl("/gist-hcp/")
        setHomeLogo(defaultLogo)
        break
      case "ism":
        console.log("ism")
        setHomeUrl("/ism/")
        setHomeLogo(ismLogo)
        setHomeLogoAlt("AYVAKIT® logo")
        break
      case "advsm":
        console.log("advsm")
        setHomeUrl("/advsm/")
        setHomeLogo(defaultLogo)
        break
      case "gateway":
        console.log("gateway")
        setHomeUrl("/")
        setHomeLogo(defaultLogo)
        setHomeLogoAlt("AYVAKIT® logo")
        break
      default:
        setHomeLogo(defaultLogo)
        console.log(`Sorry, we are out of ${props.site}.`)
        break
    }

    const handleHashScroll = () => {
      if (window.location.hash === "#isi") {

        // Add a timeout to ensure the DOM is fully rendered
        setTimeout(() => {
          const element = document.querySelector("#isi");
          if (element) {
            const isMobile = window.innerWidth <= 768; // Adjust breakpoint as needed
            const offset = isMobile ? 130 : 0; // Offset for mobile header

            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          }
        }, 1000); // Delay to ensure the element is rendered
      }
    };

    // Run the handler on initial render
    handleHashScroll();

    return () => {
      mediaQuery.removeListener(handleMediaQueryChange)
    }
  }, [])
  

  const handleMediaQueryChange = mediaQuery => {
    if (mediaQuery.matches) {
      setIsSmallScreen(true)
    } else {
      setIsSmallScreen(false)
    }
  }
  const toggleNav = e => {
    let newValue = !isNavVisible;
    setNavVisibility(prevValue => {
      newValue = !prevValue;
      return newValue;
    });
    if (window.innerWidth < 769) {
      document.body.style.overflowY =
      document.body.style.overflowY === "hidden" ? "visible" : "hidden"
    }
    if (e.target.className === "mobile-subnav") {
      setNavVisibility(true)
      newValue = true
      document.body.style.overflowY = "hidden"
      
      e.target.parentElement.classList.toggle("active")
      
      document.querySelector(
        ".gatsby-image-wrapper.Hamburger.HamburgerClose"
      ).style.display = "block"
    }

    if (newValue === true) {
      document.querySelector(
        ".gatsby-image-wrapper.Hamburger.HamburgerClose"
      ).style.display = "block"
    }
    if (newValue === false || newValue === undefined) {
      document.querySelector(
        ".gatsby-image-wrapper.Hamburger.HamburgerClose"
      ).style.display = "none"
    }

  }

  function removeBodyLock() {
    document.body.style.overflowY = "visible"
  }

  const isiLinkClick = e => {
    let globalIsi = document.querySelector(".global-isi")
    globalIsi.classList.add("inline")
    console.log(props.site)
    if (props.site === "gateway") {
      window.location.href = "/#isi"
    }
  }

  return (
    <header className="Header">
      <span>For US Healthcare Professionals Only</span>
      <div className="LogoContainer">
        <Link to={homeUrl}>
          <img src={`${homeLogo}`} alt={homeLogoAlt} className="Logo" />
        </Link>
      </div>
      {(!isSmallScreen || isNavVisible) && (
        <div className="NavContainer" id="mobile-menu" onClick={toggleNav}>
          <p className="header-disclaimer">
            For US Healthcare Professionals Only
          </p>
          <div className="Nav">
            <MobileSubMenu site={props.site} />
            <Link
              href="https://www.blueprintmedicines.com/wp-content/uploads/uspi/AYVAKIT.pdf"
              target="_blank"
              onClick={removeBodyLock}
              tabIndex={0}
            >
              Full Prescribing Information
            </Link>
            <a
              href="#isi"
              title="Important Safety Information"
              tabIndex={0}            >
              Important Safety Information
            </a>
            {props.site == "gateway" && (
              <Link
                to="https://ayvakit.com/"
                target="_blank"
                tabIndex={0}
                onClick={removeBodyLock}
              >
                Patient Site
              </Link>
            )}
            {props.site == "gist" && (
              <>
                <Link
                  to="https://ayvakit.com/pdgfra-gist/"
                  target="_blank"
                  onClick={removeBodyLock}
                >
                  Patient Site
                </Link>
                <Link to="/gist-hcp/#contact-us" onClick={removeBodyLock}>
                  Contact a Rep
                </Link>
              </>
            )}
            {props.site == "advsm" && (
              <>
                <Link
                  to="https://ayvakit.com/advanced-systemic-mastocytosis/"
                  target="_blank"
                  onClick={removeBodyLock}
                >
                  Patient Site
                </Link>
                <a href="/advsm/resources/#sign-up" onClick={removeBodyLock}>
                  Contact a Rep
                </a>
              </>
            )}
            {props.site == "ism" && (
              <>
                <Link
                  to="https://ayvakit.com/indolent-systemic-mastocytosis/"
                  target="_blank"
                  onClick={removeBodyLock}
                  tabIndex={0}
                >
                  Patient Site
                </Link>
                <Link 
                  to="/ism/connect-with-us"
                  onClick={removeBodyLock}
                  tabIndex={0}
                >
                  Contact a Rep
                </Link>
              </>
            )}
            {/* <Link href={`/AYVAKIT_Product_Pricing_Sheet_HCP.pdf`} target="_blank" onClick={removeBodyLock}>Product Order Information</Link> */}
            <Link
              href={ProductPricingSheet}
              target="_blank"
              onClick={removeBodyLock}
              tabIndex={0}
            >
              {" "}
              Product Order Information
            </Link>
          </div>
          <div className="NavBottom" onClick={toggleNav}></div>
        </div>
      )}
      <ConditionButton />
      <button onClick={toggleNav} className="Burger">
        <StaticImage
          src={"../../images/hamburger-gateway.png"}
          className="Hamburger HamburgerGateway"
          alt="hamburger"
          placeholder="none"
          quality={100}
        />
        <StaticImage
          src={"../../images/hamburger-advsm.png"}
          className="Hamburger HamburgerAdvsm"
          alt="hamburger"
          placeholder="none"
          quality={100}
        />
        <StaticImage
          src={"../../images/hamburger-gist.png"}
          className="Hamburger HamburgerGist"
          alt="hamburger"
          placeholder="none"
          quality={100}
        />
        <StaticImage
          src={"../../images/hamburger-ism.png"}
          className="Hamburger HamburgerIsm"
          alt="hamburger"
          placeholder="none"
          quality={100}
        />
        <StaticImage
          src={"../../images/hamburger-x.png"}
          className="Hamburger HamburgerClose"
          alt="hamburger"
          placeholder="none"
          quality={100}
        />
      </button>
    </header>
  )
}
